import { InvoiceItem } from '../../types/Invoice';
import { VatCode } from '../../types/VatCode';

/**
 * Rounds number to places
 * @param num
 * @param places
 * @returns rounded number
 */
export const roundNumber = (num: number, places?: number) => {
  if (!places && places !== 0) return num;
  return Number(Math.round(Number(num + 'e' + places)) + 'e-' + places);
};

/**
 * Calculates price of all items on invoice
 */
export const calculateTotal = (invoiceItems: InvoiceItem[]) => {
  let total = 0;
  invoiceItems.forEach((e: InvoiceItem) => {
    if (e.quantity && e.price) {
      total += e.quantity * e.price;
    }
  });
  return total;
};

/**
 * Calculates price of all items with VAT on invoice
 */
export const calculateTotalWithVat = (invoiceItems: InvoiceItem[]) => {
  let total = 0;
  invoiceItems.forEach((e: InvoiceItem) => {
    if (!e.quantity || !e.price) return;
    // rounded to 2 places, cut to 2
    total += Number(
      roundNumber(e.price * e.quantity * (e.vat ? e.vat / 100 + 1 : 1), 2).toFixed(2),
    );
  });
  return total;
};

/**
 * Groups VAT Summary data on invoice by Rate
 */
export const getGroupedVatSummaryData = (invoiceItems: InvoiceItem[], vatCodesArr: VatCode[]) => {
  let vatGroupData: any[] = [];
  let vatRates: string[] = [];
  // unique values
  invoiceItems.map((item: InvoiceItem) => {
    const code = vatCodesArr.find((x: VatCode) => x.code === item.vatCode);
    if (code && !vatRates.includes(code?.rate)) {
      vatRates = [...vatRates, code?.rate];
    }
  });
  vatRates.map((rate: string) => {
    const vatCode = vatCodesArr.find((x: VatCode) => x.rate === rate);
    let _vatBase = 0;
    let _vat = 0;
    let _total = 0;
    invoiceItems.map((item: InvoiceItem) => {
      // group data with same rate
      if (
        item.vatCode &&
        vatCodesArr.find((x: VatCode) => x.code === item.vatCode)?.rate === rate
      ) {
        _vatBase += item.price * item.quantity;
        _vat += item.price * (item.vat / 100) * item.quantity;
        _total += (item.price + item.price * (item.vat / 100)) * item.quantity;
      }
    });
    vatGroupData = [
      ...vatGroupData,
      {
        code: vatCode?.code,
        ratio: vatCode?.coefficientPercent,
        rate: vatCode?.rate,
        vatBase: _vatBase,
        vat: _vat,
        total: _total,
      },
    ];
  });
  return vatGroupData;
};
